import React, {Fragment, useEffect} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import RequestQuoteOutlinedIcon from '@mui/icons-material/RequestQuoteOutlined';

import {UserPopupContent} from "../../../visComponents/constants";
import {setUserPopupContent, setUserTwoFa} from "../../../../actions/userFunctions";
import {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {IS_PRODUCT_JOURNEY} from "../../../../config";
import {
  loginButtonCommonClick,
  registerButtonCommonClick,
  remindPasswordCommonClick, saveQuoteAfterSignIn
} from "../../../../misc/userFunctions";
import {sendAuthRequest} from "../../ui/twoFaCodeInput";
import {pricingIsLocked} from "../../lookNavigation/lookNavigationFunctions";
import {SHARE_BUTTONS} from "../../lookNavigation/lookSideBar/lookSidebarModals/lookSideBarShareButtons";
import {saveQuoteAndShare} from "../../lookNavigation/lookFunctions2";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {setLookAiImageOpened} from "../../../ai/aiActions";
import {LOOK_OVERLAYS} from "../../core/constants";

const LeadCapturePopupFooterSubmit = (props) => {

  const {userPopupContent, updateInputValidations, setUserPopupContent, closePopup, fabricatorSettings,
    isPhoneNumberValidated, userInfo, userIsLoggedIn, twoFALoading, setUserTwoFa, lookOverlayAction, setLookOverlayOpened,
    setLookAiImageOpened} = props;

  const {pricingLocked} = pricingIsLocked(); // leadCapture is on
  const isQuotation = fabricatorSettings.callForPricing && lookOverlayAction && lookOverlayAction === "quotation"
    && (userPopupContent === UserPopupContent.register || userPopupContent === UserPopupContent.login);

  useEffect(() => {
    if ((userPopupContent === UserPopupContent.login || userPopupContent === UserPopupContent.register) && userIsLoggedIn && !isPhoneNumberValidated) {
      tryToSwitchToTwoFa()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPopupContent])

  const tryToSwitchToTwoFa = () => {
    if (fabricatorSettings.twoFA && !isPhoneNumberValidated) {
      setUserPopupContent(UserPopupContent.twoFA);
      return true
    }
    return false
  }

  const resendSMSButtonClick = async () => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupTwoFAResendCode
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupTwoFAResendCode;

    sendAuthRequest(twoFALoading, analyticsLabel, userInfo, userIsLoggedIn, 1, setUserTwoFa);
  };

  const receiveCallButtonClick = async () => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupTwoFAReceiveCall
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupTwoFAReceiveCall;

    sendAuthRequest(twoFALoading, analyticsLabel, userInfo, userIsLoggedIn, 2, setUserTwoFa);
  };

  const submitButtonClick = async () => {

    const fromShare = lookOverlayAction && Object.keys(SHARE_BUTTONS).some(button => lookOverlayAction === button);
    const fromAI = lookOverlayAction === "aiLeadCapture";

    switch (userPopupContent) {
      case UserPopupContent.register: {
        const executeAfterRegister = async () => {
          const saveResponse = await saveQuoteAfterSignIn();
          if (tryToSwitchToTwoFa()) {
            return false
          }
          closePopup(!(fromAI && saveResponse)); // do not close overlay, we will open ai overlay
          if (fromShare && saveResponse) {
            await saveQuoteAndShare(lookOverlayAction, "", false, saveResponse.imageUrl)
          } else if (fromAI && saveResponse) {
            setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
            setLookAiImageOpened(true);
          }
        };
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupRegister
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupRegister;
        const registered = await registerButtonCommonClick(updateInputValidations, analyticsLabel, executeAfterRegister);
        if (!registered) {
          return false
        }
        await executeAfterRegister()
        break;
      }
      case UserPopupContent.login: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupLogin
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupLogin;
        const loginResponse = await loginButtonCommonClick(updateInputValidations, analyticsLabel);
        if (!loginResponse || loginResponse.error) {
          console.error("something is wrong with login response", loginResponse);
          return false
        }
        const saveResponse = await saveQuoteAfterSignIn();
        if (!loginResponse.isPhoneNumberValidated && tryToSwitchToTwoFa()) {
          return false
        }
        closePopup(!(fromAI && saveResponse)); // do not close overlay, we will open ai overlay
        if (fromShare && saveResponse) {
          await saveQuoteAndShare(lookOverlayAction, "", false, saveResponse.imageUrl)
        } else if (fromAI && saveResponse) {
          setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
          setLookAiImageOpened(true);
        }
        break;
      }
      case UserPopupContent.terms:
        setUserPopupContent(UserPopupContent.register);
        break;
      case UserPopupContent.forgot: {
        const analyticsLabel = IS_PRODUCT_JOURNEY
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.leadCapturePopupForgotPassword
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLeadCapturePopupForgotPassword;
        await remindPasswordCommonClick(updateInputValidations, analyticsLabel);
        break;
      }
      case UserPopupContent.twoFA:
        setUserPopupContent(UserPopupContent.twoFAVerify);
        break;
      case UserPopupContent.twoFAVerify: {
        await resendSMSButtonClick();
        break;
      }
      default:
        break;
    }
  }

  const getSubmitButtonText = () => {
    switch (userPopupContent) {
      case UserPopupContent.login:
        if (isQuotation) {
          return "leadCapturePopup.quotationButton"
        } else if (lookOverlayAction && Object.keys(SHARE_BUTTONS).some(button => lookOverlayAction === button)) {
          return "leadCapturePopup.shareButton";
        } else if (fabricatorSettings.enableQuote) {
          return "leadCapturePopup.getQuote";
        } else if (pricingLocked) {
          return "leadCapturePopup.loginButton";
        }
        return "leadCapturePopup.saveDesignButton";
      case UserPopupContent.register:
      default:
        // if (pricingLocked) {
        //   return "leadCapturePopup.unlockButton";
        // }
        if (isQuotation) {
          return "leadCapturePopup.quotationButton"
        } else if (lookOverlayAction && Object.keys(SHARE_BUTTONS).some(button => lookOverlayAction === button)) {
          return "leadCapturePopup.shareButton";
        } else if (fabricatorSettings.enableQuote) {
          return "leadCapturePopup.getQuote";
        }
        return "leadCapturePopup.saveDesignButton";
      case UserPopupContent.terms:
        return "buttons.back";
      case UserPopupContent.forgot:
        return "leadCapturePopup.forgot.title";
      case UserPopupContent.twoFA:
        return "buttons.next";
      case UserPopupContent.twoFAVerify:
        return "grohe.cart.twoFA.verify.resendCodeButton";
    }
  };

  return (
    <Fragment>
      {userPopupContent === UserPopupContent.twoFAVerify ? (
        <div className="grohe-lead__footer-cell grohe-lead__footer-cell--with-right">
          <Button className="look-button look-button--secondary look-button--medium grohe-look__button look-button--140"
                  onClick={receiveCallButtonClick}>
            <FormattedMessage id="grohe.cart.twoFA.verify.receiveCallButton"/>
          </Button>
        </div>
      ) : null}
      <div className="grohe-lead__footer-cell">
        <Button className={"look-button look-button--medium grohe-look__button "
          + (userPopupContent === UserPopupContent.forgot
            ? " look-button--160"
            : isQuotation ? "" : " look-button--140")
          + (userPopupContent === UserPopupContent.twoFAVerify ? " look-button--secondary" : " look-button--primary")}
                startIcon={isQuotation ? <RequestQuoteOutlinedIcon/> : null}
                onClick={submitButtonClick}>
          <FormattedMessage id={getSubmitButtonText()}/>
        </Button>
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {userPopupContent, userInfo, userIsLoggedIn, userTwoFa} = store.userState;
  const {settings} = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;
  const {twoFALoading} = userTwoFa;
  const {lookOverlayAction} = store.lookState;

  return {
    userPopupContent,
    userInfo,
    userIsLoggedIn,
    twoFALoading,
    fabricatorSettings: settings,
    isPhoneNumberValidated,
    lookOverlayAction,
  };
};

LeadCapturePopupFooterSubmit.propTypes = {
  updateInputValidations: PropTypes.func.isRequired,
  closePopup: PropTypes.func.isRequired
}

const mapDispatchToProps = {
  setUserPopupContent,
  setUserTwoFa,
  setLookOverlayOpened,
  setLookAiImageOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeadCapturePopupFooterSubmit)
)
